import React, { useEffect, useState, useContext } from "react";
// react-bootstrap components
import { Card, Container, Row, Col } from "react-bootstrap";
import { apiService } from "../../../service/ApiService";
import { useHistory } from "react-router-dom";
import { notificationService } from "../../../service/NotificationService";
import CreateTableBtn from "components/Buttons/CreateTableBtn";
import StoreContext from "contexts/StoreContext";
import HippoTable from "components/ReactTable/HipposReactTable";
import StatusColumn from "components/Custom/StatusColumn";
import TimestampColumn from "components/Custom/TimestampColumn";
import EditButton from "views/Components/EditButton";
import { ClipLoader } from "react-spinners";

import { useTranslation } from "react-i18next";

function PricelistListPage() {
  const {
    t,
  } = useTranslation();

  const history = useHistory();
  const [data, setData] = useState([]);
  const { storeId, setStoreId } = useContext(StoreContext);
  const [alert, setAlert] = useState(null);
  const [showLoader, setShowLoader] = useState(true);

  const columns = [
    {
      Header: "ID",
      accessor: "id",
    },
    {
      Header: t("tables.headers.designation"),
      accessor: "name",
    },
    {
      Header: t("tables.headers.status"),
      accessor: "status",
    },
    {
      Header: t("tables.headers.actions"),
      accessor: "edit",
      minWidth: 200,
      maxWidth: 200,
      width: 200,
    },
  ];

  const fetchData = async () => {
    setShowLoader(true);
    try {
      const dataResponse = await apiService.get(`api/v1/pricelists/store/${storeId}`);
      setData(attachCustom(dataResponse));
    } catch (error) {
      console.error("Error fetching data:", error);
      notificationService.notifyWarn(error.message);
    } finally {
      setShowLoader(false);
    }
  };

  const attachCustom = (data) => {
    const enhanced = data.map((el) => {
      el.status = <StatusColumn value={el.deleted} />;
      el.timestamp = <TimestampColumn timestamp={el.updatedAt} />;
      el.edit = <EditButton uri={`/admin/pricelist/${el.id}`} />;
      return el;
    });
    return enhanced;
  };

  useEffect(() => {
    if (!storeId) return;
    fetchData();
  }, [storeId]);

  return (
    <>
      {alert}
      <Container fluid>
        <Row>
          <Col md="12">
            <Card>
              <Card.Body>
                <Row>
                  <CreateTableBtn route={"/admin/pricelist"} />
                </Row>
                <Row>
                  <Col>
                    {showLoader ? (
                      <div style={{ textAlign: "center", marginTop: "5vh", marginBottom: "5vh" }}>
                        <ClipLoader size={50} color={"#ff6fbc"} />
                      </div>
                    ) : (
                      <HippoTable data={data} columns={columns} className="-striped -highlight primary-pagination" />
                    )}
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default PricelistListPage;
